export const articlesAR = [

  'Recognition',
  'Appointments',
  'Benefits and retirement programs',
  'Health benefits plan changes for 2023',
  'Bridge funding',
  'Child care',
  'Compensation',
  'Coordinator of public programs series',
  'Corrective action and dismissal',
  'Grievance and arbitration procedures',
  'Health and safety',
  'Holidays',
  'Housing and relocation',
  'International scholar and immigrant support',
  'Labor management meetings',
  'Layoff and reduction in time',
  'Leaves of absence',
  'Management and academic rights',
  'Medical separation',
  'No strikes',
  'Nondiscrimination in employment',
  'Out of unit movement',
  'Parking and transit',
  'Past practice not covered by agreement',
  'Personnel files',
  'Professional research series',
  'Project scientist series',
  'Reasonable accommodation',
  'Respect is part of research training',
  'Respectful work environment',
  'Severability',
  'Sick leave',
  'Specialist series',
  'Time and effort commitment',
  'Training',
  'Travel reimbursement',
  'Union access and rights',
  'Union security',
  'Vacation',
  'Waiver',
  'Work-incurred injury and illness',
  'Duration of agreement',
  'Appendix H',
  'Appendix YY',
  'Ground rules',
  'Extension of previous contract',

];

const recognitionProposals = [

  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },

];

const appointmentsProposals = [
  {

    name: 'Tentative agreement | Nov. 2, 2022',
    link: 'https://drive.google.com/file/d/1LLs5iCOnnhlKjyCuKFjEAO66fX0KRwCw/view',
    color: 'success',

  },
];

const benefitsRetirementPrograms = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1o_X6YadXS16NEn7kzNT53K_TaRZbVaHy/view?usp=sharing',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UAW to UC | Nov. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1EpmcAZUJGrXm-A7zO84SolCLyCktiITV/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1-RrNTZc-uyQQ4orlPibGZwNRSMRR5we9/view?usp=share_link',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1HCFX6xJ27lIypT7wp4tDCOdf8KSCxTcP/view ',
  //   color: 'secondary',
  // },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1EkUXWkUoa5u7Z57ZpY2CGAXFz-2DKE1O/view?usp=sharing',
    color: 'success',

  },

];

const healthBenefitsPlanChangesProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 12, 2022',
  //   link: 'https://drive.google.com/file/d/14HaYk49geI941IE6T4uDRSH_sFHcSFzs/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1Ts6BoI1QjIqn5GoQJm_R63A5VeygsxvS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1-RrNTZc-uyQQ4orlPibGZwNRSMRR5we9/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1HCFX6xJ27lIypT7wp4tDCOdf8KSCxTcP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 18, 2022',
  //   link: 'https://drive.google.com/file/d/1BkJHUL4s8dFTBoDI_yzAGNRI5cImig54/view',
  //   color: 'secondary',
  // },
];

const bridgeFundingProposals = [
  // {
  //   name: 'Proposal | UAW to UC | July 22, 2022',
  //   link: 'https://drive.google.com/file/d/1aoc1laJ9J05pOXfYvGNDDi90wqdNOOjt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sep. 9, 2022',
  //   link: 'https://drive.google.com/file/d/1Ts6BoI1QjIqn5GoQJm_R63A5VeygsxvS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1yFCH-5kBavKEpW26OD_I7isfu5kNNfq5/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1-RrNTZc-uyQQ4orlPibGZwNRSMRR5we9/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1HCFX6xJ27lIypT7wp4tDCOdf8KSCxTcP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 18, 2022',
  //   link: 'https://drive.google.com/file/d/1BkJHUL4s8dFTBoDI_yzAGNRI5cImig54/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1NKOjzLQb0OfJQ_ulTW5dcbf9nVEKs0nN/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1FB6BgNiFc3v6BOtWhcjq4u3tbMEoqiIf/view',
  //   color: 'secondary',
  // },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1FB6BgNiFc3v6BOtWhcjq4u3tbMEoqiIf/view',
    color: 'success',

  },

];

const childCareProposals = [

];

const compensationProposals = [
  {
    name: 'Proposal | UC to UAW | June 29, 2022',
    link: 'https://drive.google.com/file/d/1D-fX9xd7BUGFgK51Yy9Y2-VGHaftEpdR/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | July 22, 2022',
    link: 'https://drive.google.com/file/d/1kMh9j_uciOcrXER_9VlNpDkaHz7sb8M-/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Oct. 14, 2022',
    link: 'https://drive.google.com/file/d/1Ye3Ei2Kn6Rajhelu4JSgH981up5m6PZR/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Nov. 12, 2022',
    link: 'https://drive.google.com/file/d/1EpmcAZUJGrXm-A7zO84SolCLyCktiITV/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1ZpEl8wgP9O_JyjsP4w5Z5jZjZxxHqr12/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1-RrNTZc-uyQQ4orlPibGZwNRSMRR5we9/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1y1Gj6QPjKKM5lK8d9Gxv7L9FyFP3Yz19/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1HCFX6xJ27lIypT7wp4tDCOdf8KSCxTcP/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 19, 2022',
    link: 'https://drive.google.com/file/d/1tC3O9ZM8_dvFiiOy8bV85kLp93ase-Ld/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 19, 2022',
    link: 'https://drive.google.com/file/d/1NKOjzLQb0OfJQ_ulTW5dcbf9nVEKs0nN/view?usp=share_link',
    color: 'secondary',
  },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1pY83zLYu14-X9lEy9s16Q-VlpUuZ55xv/view?usp=sharing',
    color: 'success',

  },
];

const coordinatoroOfPublicProgramsSeries = [
  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1taKvTBqZl6EFRLVccCCubDUo8F2eyQz7/view?usp=share_link',
    color: 'success',

  },
];

const correctiveActionAndDismissalsProposals = [
  {

    name: 'Tentative agreement | Sep. 30, 2022',
    link: 'https://drive.google.com/file/d/12_z5c68MGXyKXxw_EexGHkNe8gxqNqyg/view?usp=sharing',
    color: 'success',
  },
];

const grievanceArbitrationProceduresProposals = [
  {

    name: 'Tentative agreement | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/14smcfrPoiQANSJ2FPtp98WQdbkK0a0tw/view?usp=share_link',
    color: 'success',

  },
];

const healthAndSafetyProposals = [
  {

    name: 'Tentative agreement | Aug. 12, 2022',
    link: 'https://drive.google.com/file/d/1SI6JXnKOPGyJoDDALzSckmAnGjlY7nVR/view?usp=sharing',
    color: 'success',

  },
];
const holidaysProposals = [
  {

    name: 'Tentative agreement | June 3, 2022',
    link: 'https://drive.google.com/file/d/1-4iuPV_NT0k7FzjOxPKkA4oC8thuJUoU/view?usp=sharing',
    color: 'success',

  },
];

const housingAndRelocationProposals = [
];

const internationalScholarAndImmmigrantSupportProposals = [

];

const laborManagementMeetingsProposals = [
  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },
];

const layoffAndReductionInTimeProposals = [
  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1nEdlUtxWioZGM1OK6uG3cG28zopqZYi4/view?usp=share_link',
    color: 'success',

  },
];

const leavesOfabsenceProposals = [
  // {
  //   name: 'Proposal | UAW to UC | June 10, 2022',
  //   link: 'https://drive.google.com/file/d/1OEAIkJIynK3XP2vZTNRyTqK_KVMF2G1P/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | July 15, 2022',
  //   link: 'https://drive.google.com/file/d/15-Uz1jK2kI-pr1Kjulehx9QqNRHo7oqq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1-IYF8xGtd-CuWQy6W4_zGLr0z6DdAaLY/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Aug. 26, 2022',
  //   link: 'https://drive.google.com/file/d/1OOKGrci3x8wbwiSZ_is2gLvpIqOnK5BT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sep. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1G_VtS_e2G5Lr_KS9lDSarTdGiIfeY6uW/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1-RrNTZc-uyQQ4orlPibGZwNRSMRR5we9/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1HCFX6xJ27lIypT7wp4tDCOdf8KSCxTcP/view?usp=sharing',
  //   color: 'secondary',
  // },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1OOKGrci3x8wbwiSZ_is2gLvpIqOnK5BT/view',
    color: 'success',

  },
];

const managementAcademicProposals = [

  {

    name: 'Tentative agreement | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1lVcbYMKyE2LaXz_cXqzZysPm9C-Q_nRw/view',
    color: 'success',

  },

];

const medicalSeparationProposals = [

  {

    name: 'Tentative agreement | Nov. 2, 2022',
    link: 'https://drive.google.com/file/d/1LLs5iCOnnhlKjyCuKFjEAO66fX0KRwCw/view',
    color: 'success',

  },

];

const noStrikesProposals = [

  // {
  //   name: 'Proposal | UC to UAW | June 3, 2022',
  //   link: 'https://drive.google.com/file/d/1KjrjUXcGHNmf0CjsJjNICnUxNcUKIvas/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | June 24, 2022',
  //   link: 'https://drive.google.com/file/d/1a_Sy9HUnOeCvXfi7e2EYt3ZzfPe621zF/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1XoL_M1dLGjzLOYvbdTVpNBv0I_M962RS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1VOoX-4Dg1MwEZxuoA1uyhQFXlmmFr8BY/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1rgx_Y8m-F5bYoAUwoHSA1JEzNZY7du1q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1VOoX-4Dg1MwEZxuoA1uyhQFXlmmFr8BY/view?usp=share_link',
  //   color: 'secondary',
  // },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1EkUXWkUoa5u7Z57ZpY2CGAXFz-2DKE1O/view?usp=sharing',
    color: 'success',

  },

];

const nondiscriminationProposals = [
  {

    name: 'Tentative agreement | Sept. 30, 2022',
    link: 'https://drive.google.com/file/d/1pYmBVjQtXaks8p9XAD2LIQ6rq8TnpugZ/view',
    color: 'success',

  },
];

const outOfUnitProposals = [

  {

    name: 'Tentative agreement | Nov. 2, 2022',
    link: 'https://drive.google.com/file/d/1LLs5iCOnnhlKjyCuKFjEAO66fX0KRwCw/view?usp=share_link',
    color: 'success',

  },
];

const parkingTransitProposals = [

  // {
  //   name: 'Proposal | UAW to UC | June 3, 2022',
  //   link: 'https://drive.google.com/file/d/1MQJ7x5mlNsYeN0vuGdHINHprhq0PQrao/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 10, 2022',
  //   link: 'https://drive.google.com/file/d/1vM5CO51axCddELvKAvNf7nY1SvcSbgPa/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1XoL_M1dLGjzLOYvbdTVpNBv0I_M962RS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Supposal | UC to UAW | Nov. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1SEDJRZYIczMtyaMahoM328C8lBNElsON/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 4, 2022',
  //   link: 'https://drive.google.com/file/d/12RICqbQyrImKYyBJ75F99de8phiR_rb2/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1EpmcAZUJGrXm-A7zO84SolCLyCktiITV/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/16anVAkA8I-pdcWW5kUygJzSrP_8EXC3Z/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1D8RDO-LOtVfQgPyPJRDGLNWvJvUkmIh-/view?usp=share_link',
  //   color: 'secondary',
  // },
  {

    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1klXNpZ7cgKAYUn4Wu5lfo1y_cHR4DydR/view?usp=sharing',
    color: 'success',

  },

];

const pastPracticesProposals = [

  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },

];

const personnelProposals = [
  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },

];

const professionalResearcherProposals = [

  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/12Kfl0wUNSkqD1cxLgPeXD4XPMgXZv9N_/view?usp=share_link',
    color: 'success',

  },
];

const projectScientistProposals = [

  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1k3DDYDXc3I15K7EdbVNN2B7TEM0ZsF7x/view?usp=share_link',
    color: 'success',

  },
];

const reasonableAccommodProposals = [

  {

    name: 'Tentative agreement | Oct. 28, 2022',
    link: 'https://drive.google.com/file/d/1cSkdSOVLIwgt1Nw_fCqDuvkLcQ6TSkou/view?usp=share_link',
    color: 'success',

  },

];

const respectPartProposals = [];

const respectfulWorkProposals = [

  {

    name: 'Tentative agreement | Oct. 1, 2022',
    link: 'https://drive.google.com/file/d/1OC7-TnoO3B6QXw15q_vNVZ3duG4Ex-hU/view?usp=sharing',
    color: 'success',

  },
];

const severabilityProposals = [
  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },
];
const sickLeaveProposals = [

  {

    name: 'Tentative agreement | Oct. 19, 2022',
    link: 'https://drive.google.com/file/d/1HXOgDamS5Ty_e5md8Xgpca73Vk-oqj7u/view?usp=sharing',
    color: 'success',

  },

];
const specialistProposals = [

  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/16GPxFoABGgyzL0EZspNH1a1MlLF3L7e5/view?usp=share_link',
    color: 'success',

  },
];
const timeEffortProposals = [
  {

    name: 'Tentative agreement | Sept. 30, 2022',
    link: 'https://drive.google.com/file/d/1Gbl6ouJaNjgxm5Wx1WfIEgA83-DckFa6/view',
    color: 'success',

  },

];
const trainingProposals = [{

  name: 'Tentative agreement | June 24, 2022',
  link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
  color: 'success',

}];
const travelReimbursementProposals = [{

  name: 'Tentative agreement | June 24, 2022',
  link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
  color: 'success',

}];
const unionAccessProposals = [

  {

    name: 'Tentative agreement | Nov. 2, 2022',
    link: 'https://drive.google.com/file/d/1LLs5iCOnnhlKjyCuKFjEAO66fX0KRwCw/view',
    color: 'success',

  },

];
const unionSecurityProposals = [

  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1ZV8nSbsjgJK8XqaL2ZoI8IJNIPAuzQDc/view',
    color: 'success',

  },

];
const vacationProposals = [

  {

    name: 'Tentative agreement | Oct. 19, 2022',
    link: 'https://drive.google.com/file/d/1HXOgDamS5Ty_e5md8Xgpca73Vk-oqj7u/view?usp=sharing',
    color: 'success',

  },
];

const waiverProposals = [

  {

    name: 'Tentative agreement | June 24, 2022',
    link: 'https://drive.google.com/file/d/1K8zj1xCsaJ7MQJCnsxOWWX6SH0xRBqpd/view?usp=sharing',
    color: 'success',

  },

];

const workIncurredProposals = [

  {

    name: 'Tentative agreement | Sept. 30, 2022',
    link: 'https://drive.google.com/file/d/1Gbl6ouJaNjgxm5Wx1WfIEgA83-DckFa6/view',
    color: 'success',

  },
];

const durationProposals = [

  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/19Su8OtlYZrLgyHv5EtBvyjY6SOpCXUdT/view?usp=sharing',
    color: 'success',
  },

];
const appendixHProposals = [

  {

    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1IhU-N8ZqX4v6MkrCZEU1w57fhbBACgt1/view?usp=share_link',
    color: 'success',

  },

];
const appendixYYProposals = [

  {

    name: 'Tentative agreement | Nov. 2, 2022',
    link: 'https://drive.google.com/file/d/1AlnBpaczrxvZIRuUpifxXfV-C8T5ZIDB/view?usp=sharing',
    color: 'success',

  },

];
const groundRulesProposals = [

  {

    name: 'Tentative agreement | June 28, 2022',
    link: 'https://drive.google.com/file/d/1CY7PRm3BSs7UBah26gwbLW4uzWtP3Ms2/view?usp=sharing',
    color: 'success',

  },

];
const extensionProposals = [

  {

    name: 'Extension of previous contract to Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1BuhRM8jF4uuFMrdSnwTusIzV8tVqpbjC/view?usp=sharing',
    color: 'secondary',

  },

];

export const infoAR = {

  Recognition: {

    proposals: recognitionProposals,
    intro: 'A tentative agreement on recognition was reached June 24, 2022, as part of a package of proposals. The package agreement maintained the language of eight articles from the previous contract between the UAW Local 5810 and the UC system.',

  },
  Appointments: {

    proposals: appointmentsProposals,
    intro: 'On Nov. 2, 2022, a tentative agreement on a package deal maintained the language of their previous appointments article.',

  },

  'Benefits and retirement programs': {

    proposals: benefitsRetirementPrograms,
    intro: 'The UAW Local 5810’s proposals have included eligibility for enrollment in health and retirement plans and a $10 per month cap on increases to AR contributions for benefit plans. After one package and one proposal, parties moved to maintain their previous contract language for this article on Nov. 28, 2022.',

  },

  'Health benefits plan changes for 2023': {

    proposals: healthBenefitsPlanChangesProposals,
    intro: 'Parties tentatively agreed to withdraw this article Nov. 28, 2022. Previously, parties had negotiated the extent of coverage of mental health, gender-affirming and IVF treatments. None of those terms were used in their earlier contract.',

  },

  'Bridge funding': {

    proposals: bridgeFundingProposals,
    intro: 'Bridge funding is provided by the UC system to ensure the continuity of an AR\'s research during periods of insufficient external funding. A Nov. 12, 2022 package from UAW Local 5180 set forth guidelines for ARs\' eligibility for bridge funding of up to $100,000. However, a Nov. 28, 2022 tentative agreement forwards a Nov. 19, 2022 proposal that states the joint labor management committee should convene to discuss bridge funding.',

  },

  'Child care': {

    proposals: childCareProposals,
    intro: 'In November 2022, the UAW Local 5810 withdrew its child care proposal asking the UC system to subsidize UC child care programs for ARs. The union’s last contract did not contain a child care article.',

  },

  Compensation: {

    proposals: compensationProposals,
    intro: 'While a tentative agreement was reached Nov. 28, 2022, the complete proposal history is attached for this article.',

  },

  'Coordinator of public programs series': {

    proposals: coordinatoroOfPublicProgramsSeries,
    intro: 'Coordinators of public programs, or CPPs, are ARs that oversee programs that serve the public in education, health and labor. In mid-November, both parties reached a tentative agreement on eligibility criteria, longer terms of appointments and promotion guidelines for CPPs.',

  },

  'Corrective action and dismissal': {

    proposals: correctiveActionAndDismissalsProposals,
    intro: 'The UC system and the UAW Local 5810 reached a tentative agreement as part of a package proposal Sept. 30, 2022 on what corrective actions the UC system can take to address ARs’ potential misconduct, subpar performance or violation of UC policy.',

  },
  'Grievance and arbitration procedures': {

    proposals: grievanceArbitrationProceduresProposals,
    intro: 'On Nov. 13, 2022, the UAW Local 5810 and the UC system tentatively agreed on procedures for ARs to file grievances with a right to be represented by the UAW.',

  },

  'Health and safety': {

    proposals: healthAndSafetyProposals,
    intro: 'In August 2022, both parties tentatively agreed that the UC system and the union share the responsibility of maintaining a safe working environment with proper equipment.',

  },

  Holidays: {

    proposals: holidaysProposals,
    intro: 'In June 2022, both parties tentatively agreed on 14 holidays, including Juneteenth. ARs whose projects require working on holidays should receive an alternate day off under the agreement.',

  },

  'Housing and relocation': {

    proposals: housingAndRelocationProposals,
    intro: 'On Nov. 12, 2022, the UAW Local 5180 proposed that the UC system make UC-provided housing available for all ARs with rent that is no more than 30% of their salary. If UC housing is not available, the UC system should pay ARs in subsidies, under the union’s proposal. On Nov. 28, 2022, UAW Local 5810 withdrew this article as part of a tentative package agreement.',

  },

  'International scholar and immigrant support': {

    proposals: internationalScholarAndImmmigrantSupportProposals,
    intro: 'On Nov. 19, 2022, the UAW Local 5810 withdrew their proposal for this new article.',

  },
  'Labor management meetings': {

    proposals: laborManagementMeetingsProposals,
    intro: 'Both parties came to a tentative agreement on labor management meetings in June 2022 as part of a package that maintained the language of eight articles from their previous contract.',

  },
  'Layoff and reduction in time': {

    proposals: layoffAndReductionInTimeProposals,
    intro: 'On Nov. 18, 2022, UAW Local 5180 came to a tentative agreement on layoffs and reduced work hours.',

  },
  'Leaves of absence': {

    proposals: leavesOfabsenceProposals,
    intro: 'On Nov. 28, 2022, both parties tentatively agreed to the UC system\'s Aug. 26, 2022 proposal for this article.',

  },

  'Management and academic rights': {

    proposals: managementAcademicProposals,
    intro: 'On Nov. 13, 2022, both parties reached a tentative agreement on an Aug. 26, 2022 UC proposal that outlines the rights of the UC system’s faculty and academic administrators.',

  },
  'Medical separation': {

    proposals: medicalSeparationProposals,
    intro: 'Medical separation is a separation from employment when an AR is unable to perform the essential assigned functions of their position due to a disability. In a package with four other articles, both parties reached a tentative agreement in early November to maintain previous contract language on medical separation.',

  },
  'No strikes': {

    proposals: noStrikesProposals,
    intro: 'In multiple proposal packages, the UC system has proposed to maintain the previous contract language prohibiting strikes; the union’s June 24, 2022 response contained the previous contract’s version of this article, written in striked out text. However, both parties tentatively agreed on the previous contract language for this article Nov. 28, 2022, barring union strikes.',

  },
  'Nondiscrimination in employment': {

    proposals: nondiscriminationProposals,
    intro: 'On Sept. 30, 2022, both parties came to a tentative agreement on a UAW version of the article.',

  },
  'Out of unit movement': {

    proposals: outOfUnitProposals,
    intro: 'In a package proposal with 4 other articles, UAW Local 5180 and the UC system reached a tentative agreement Nov. 11, 2022, to maintain previous contract language on out of unit movement.',

  },
  'Parking and transit': {

    proposals: parkingTransitProposals,
    intro: 'Language from recent proposals in November from the UC system are showing the integration of university-provided and low-carbon emission transit options for ARs. Negotiations resulted in a Nov. 28, 2022 tentative package agreement on the Nov. 23, 2022 UC system proposal linked below.',

  },
  'Past practice not covered by agreement': {

    proposals: pastPracticesProposals,
    intro: 'In June 2022, the union and UC reached a tentative agreement to maintain previous contract language in a package proposal with eight other articles.',

  },
  'Personnel files': {

    proposals: personnelProposals,
    intro: 'Along with seven other articles, both parties came to a tentative agreement to maintain previous contract language regarding personnel files.',

  },
  'Professional research series': {

    proposals: professionalResearcherProposals,
    intro: 'Professional researchers are represented by the UAW Local 5180. In mid-November 2022, both parties reached a tentative agreement on eligibility criteria, longer terms of appointments and promotion guidelines for professional researchers.',

  },
  'Project scientist series': {

    proposals: projectScientistProposals,
    intro: 'Project scientists are represented by the UAW Local 5180. In mid-November 2022, both parties reached a tentative agreement on eligibility criteria, longer terms of appointments and promotion guidelines for project scientists.',

  },
  'Reasonable accommodation': {

    proposals: reasonableAccommodProposals,
    intro: 'In late-October, both parties reached a tentative agreement on reasonable accommodation for disabled ARs and need assistance to perform the essential functions of their jobs.',

  },
  'Respect is part of research training': {

    proposals: respectPartProposals,
    intro: 'The union withdrew their proposal for this new article in November 2022. The union’s original June 10, 2022 proposal moved to offer sexual harrassment prevention and response training jointly with the UC system.',

  },
  'Respectful work environment': {

    proposals: respectfulWorkProposals,
    intro: 'UAW Local 5180 and the UC system reached a tentative agreement on a new proposed article by the union that sets guidelines to maintain a respectful work environment for ARs.',

  },
  Severability: {

    proposals: severabilityProposals,
    intro: 'Along with the eight other articles in a June 2022 package proposal, both parties agreed to maintain the previous contract language on severability.',

  },
  'Sick leave': {

    proposals: sickLeaveProposals,
    intro: 'On Oct. 19, 2022, UAW Local 5180 and the UC system came to a tentative agreement to maintain previous contract language in a package proposal for sick leave and vacation. The previous contract allows full-time ARs to accumulate sick leave with one day per month.',

  },
  'Specialist series': {

    proposals: specialistProposals,
    intro: 'Specialists are represented by the UAW Local 5180. In mid-November 2022, both parties reached a tentative agreement on eligibility criteria, longer terms of appointments and promotion guidelines for specialists.',

  },
  'Time and effort commitment': {

    proposals: timeEffortProposals,
    intro: 'Both parties tentatively agreed to maintain previous contract language for time and effort commitment in late-September in a package proposal with 3 other articles. The previous contract language outlines standard work hours and overtime work and compensation rules.',

  },
  Training: {

    proposals: trainingProposals,
    intro: 'In June 2022, along with eight other articles, UAW Local 5180 and the UC system came to a tentative agreement to maintain previous contract language on training. The previous contract article rules training as paid time.',

  },
  'Travel reimbursement': {

    proposals: travelReimbursementProposals,
    intro: 'UC and the union reached a tentative agreement to maintain previous contract language on travel reimbursement.',

  },
  'Union access and rights': {

    proposals: unionAccessProposals,
    intro: 'Parties tentatively agreed to maintain their previous contract’s article on union access and rights Nov. 2, 2022, as part of a package with four other articles. Notably, attendance at union orientations is mandatory and on paid time under the previous contract.',

  },
  'Union security': {

    proposals: unionSecurityProposals,
    intro: 'The Nov. 2, 2022, tentative agreement on union security came as a package with four other proposals. It requires that a form, along with Appendix YY, be sent out to allow ARs to allow them to join the union.',

  },
  Vacation: {

    proposals: vacationProposals,
    intro: 'Both parties signed an agreement to continue their previous contract’s vacation and sick leave articles Oct. 19, 2022. The previous vacation article allows ARs to accrue up to 48 vacation days.',

  },
  Waiver: {

    proposals: waiverProposals,
    intro: 'The union and the UC system tentatively agreed to the waiver article June 24, 2022, as part of a proposal package that maintains the language of eight articles from their previous contract.',

  },
  'Work-incurred injury and illness': {

    proposals: workIncurredProposals,
    intro: 'The UAW Local 5810 and the UC system have tentatively agreed upon their previous contract’s policy for injuries and illnesses incurred at ARs’ workplaces. ARs should be afforded sick leave and vacation for “work-incurred injury or illness” under the California Workers’ Compensation Act.',

  },
  'Duration of agreement': {

    proposals: durationProposals,
    intro: 'According to a Nov. 28, 2022 tentative agreement on a Nov. 17, 2022 UC system proposal, this contract will be effect until Sept. 30, 2027.',

  },
  'Appendix H': {

    proposals: appendixHProposals,
    intro: 'Appendix H’s tentative agreement Nov. 18, 2022, established a list of arbitrators to help settle disputes. The list was required by the Nov. 13, 2022, tentative agreement regarding grievance and arbitration procedures.',

  },
  'Appendix YY': {

    proposals: appendixYYProposals,
    intro: 'A tentative agreement for Appendix YY’s language was reached Nov. 2, 2022. The appendix will accompany ARs’ union membership election form. Appendix YY states that the UC system neither discourages or encourages UAW Local 5810 membership.',

  },
  'Ground rules': {

    proposals: groundRulesProposals,
    intro: 'On June 28, 2022, the UC system and the union tentatively agreed on ground rules for the location, scheduling and written minutes of bargaining meetings. Under this agreement, bargaining meetings may not have sound or video recordings.',

  },
  'Extension of previous contract': {

    proposals: extensionProposals,
    intro: 'The previous AR contact between the UC system and the UAW Local 5810 was originally slated to be in effect until Sept. 30, 2022. That contract — which barred the union from authorizing strikes — was only extended to Oct. 31, 2022.',

  },
};
